import { render, staticRenderFns } from "./ims.vue?vue&type=template&id=fa88fce4&"
import script from "./ims.vue?vue&type=script&lang=js&"
export * from "./ims.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports